import { render } from "./transfers-page.vue?vue&type=template&id=3d8d4b33&scoped=true&ts=true"
import script from "./transfers-page.vue?vue&type=script&lang=ts"
export * from "./transfers-page.vue?vue&type=script&lang=ts"

import "./transfers-page.vue?vue&type=style&index=0&id=3d8d4b33&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8d4b33"]])

export default __exports__